import styled from 'styled-components';

export const CardWrapper = styled('div')`
  ${({ theme: { breakpoint, spacing } }) => `
    width: 100%;
    max-width: ${spacing.full};
    box-sizing: border-box;
    @media screen and (max-width: ${breakpoint.sm}) {
      background:transparent;
      box-shadow:none;
      margin-left: auto;
      margin-right: auto;
      margin-top: initial;
    }
  `}
`;

export const ButtonWrapper = styled('div')`
  ${({ theme: { breakpoint } }) => `
    display: flex;
    justify-content: center;
    align-self:center;
    margin-left:auto;
    margin-right:auto;
    margin-top:50px;
    @media screen and (max-width: ${breakpoint.sm}) {
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        margin-top:110px;
    }
    & > Button{
        height:56px;
        @media screen and (min-width: ${breakpoint.sm}) {
            width: 260px;
        }
    }
  `}
`;

export const TitleWrapper = styled('div')`
  ${({ theme: { breakpoint } }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    text-align:center;
    font-weight:bold;
    font-size:24px;
    @media screen and (max-width: ${breakpoint.sm}) {
        margin-top:120px;
        margin-left: auto;
        margin-right: auto;
        width: 190px;
    }
  `}
`;

export const TextWrapper = styled('div')`
  ${({ theme: { breakpoint } }) => `
    display: block;
    align-items: center;
    justify-content: center;
    max-width:532px;
    font-size:14px;
    text-align:center;
    margin-top:32px;
    color:#707070;

    @media screen and (min-width: ${breakpoint.sm}) {
        font-size:16px;
        max-width: 537px;
    }
  `}
`;

export const Tooltip = styled.span`
  color: #0087c8;
  cursor: pointer;
  position: relative;
`;

export const TooltipText = styled.span`
  display: none;
  position: absolute;
  z-index: 1;
  top: -50px;
  right: -76px;
  width: 250px;
  background-color: white;
  border: 0.5px solid #c3cfd7;
  border-radius: 10px;
  box-shadow: 0px 0px 6px #4c556433;
  font-size: 12px;
  color: #304e5c;
  padding: 8px 16px 8px 16px;
  ${Tooltip}:hover & {
      display: block;
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    z-index: 1;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #ffffff transparent transparent transparent;
  }
`;
